import { fromJS, List, Record } from 'immutable';
const PropertyValueRecord = Object.assign(Record({
  name: undefined,
  source: null,
  sourceId: null,
  timestamp: null,
  updatedByUserId: null,
  value: undefined,
  versions: List()
}, 'PropertyValueRecord'), {
  fromJS(json) {
    if (!json || typeof json !== 'object') {
      return json;
    }
    return PropertyValueRecord(fromJS(json));
  }
});
export default PropertyValueRecord;